import { useAuthContext } from '../../hooks/useAuthContext'
import { useCollection } from '../../hooks/useCollection'

// styles
import styles from './Home.module.css'

//components
import TransactionForm from './TransactionForm'
import TransactionList from './TransactionList'
import Reloadnew from './Reloadnew'

export default function Home() {
  const { user } = useAuthContext()
  //console.log("hm1uCol")
  const { documents, error } = useCollection(
    //'transactions', ["uid", "==", user.uid], ['name', 'desc']
    'transactions', 
    ["uid", "==", user.uid], 
    ["name", "asc"]  
    //["createdAt", "desc"]
  )
//working on sort by name here, error here
//console.log("hm2",documents)
//console.log("hm2Rl2-3:",documents[3].rl2)
  return (
    <div className={styles.container}>
      <div className={styles.sidebar}>
        <TransactionForm uid={user.uid} />
      </div>
      <div>
        {/* <h1>reload---</h1> */}
        {documents && <Reloadnew transactions={documents}/>}
      </div>
      <div className={styles.content}>
        {error && <p>{error}</p>}
        {documents && <TransactionList transactions={documents} />}
      </div>
    </div>
  )
}
